import * as React from "react";

import {
  AccordionSummaryProps,
  Box,
  makeStyles,
  AccordionSummary as MuiAccordionSummary,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import clsx from "clsx";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  iconEnd: {
    justifyContent: "space-between",
  },
}));

type Props = {
  children: React.ReactNode;
  expanded: boolean;
  isExpandable?: boolean;
  expansionIconPosition?: "start" | "end";
} & AccordionSummaryProps;

const ArrowIcon: React.FC<{ expanded: boolean; role: string }> = ({
  expanded,
  ...props
}) =>
  expanded ? (
    <KeyboardArrowDownIcon {...props} data-testid="arrowDownIcon" />
  ) : (
    <KeyboardArrowUpIcon {...props} data-testid="arrowUpIcon" />
  );

export const AccordionHeader: React.FC<Props> = ({
  children,
  expanded,
  isExpandable = true,
  expansionIconPosition = "start",
  ...props
}) => {
  const classes = useStyles();
  return (
    <MuiAccordionSummary {...props}>
      <Box
        className={clsx(classes.container, {
          [classes.iconEnd]: expansionIconPosition === "end",
        })}
      >
        {children}
        {isExpandable && (
          <ArrowIcon
            aria-expanded={expanded}
            role="button"
            expanded={expanded}
          />
        )}
      </Box>
    </MuiAccordionSummary>
  );
};
